export default __webpack_public_path__ + "static/media/berlinImage.31be6acb.svg";